/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { number as codecNumber, optional as codecOptional, string as codecString, } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { RubricRowBaseInputBaseAsJSON } from './RubricRowBaseInputBaseAsJSON';
const RubricRowBaseInputAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['id', /* #__PURE__ */ codecOptional(codecNumber)],
    ['type', /* #__PURE__ */ codecOptional(codecString)],
]), RubricRowBaseInputBaseAsJSON);
export class RubricRowBaseInputAsJSON extends RubricRowBaseInputBaseAsJSON {
    static decode(input) {
        return RubricRowBaseInputAsJSONParser.decode(input).map(res => new RubricRowBaseInputAsJSON(res));
    }
    static unsafeDecode(input) {
        return RubricRowBaseInputAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return RubricRowBaseInputAsJSONParser.encode(data);
    }
    static schema() {
        return RubricRowBaseInputAsJSONParser.schema();
    }
}
